// ═══════════════════════════════════════════════════════════════
// Settings — Layout with sub-navigation (Roles / Users)
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import { IconShieldCog, IconUsers, IconHistory } from '@tabler/icons-react';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS = [
  { label: 'Roles', path: '/settings', icon: IconShieldCog, exact: true },
  { label: 'Users', path: '/settings/users', icon: IconUsers },
  { label: 'Activity Log', path: '/settings/activity', icon: IconHistory },
];

export default function SettingsLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px', maxWidth: 1200 }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'Settings', to: '/settings' },
          ...(currentPage && currentPage.path !== '/settings' ? [{ label: currentPage.label }] : []),
        ]}
      />
      <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
        {NAV_ITEMS.map(item => {
          const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
          return (
            <Button
              key={item.path}
              variant={active ? 'filled' : 'light'}
              color={active ? brand.blurple : 'gray'}
              size="xs"
              leftSection={<item.icon size={14} />}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </Button>
          );
        })}
      </Group>
      <Outlet />
    </div>
  );
}
